var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossAttachment = function SvgCrossAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.544 20.69c-.72.719-.735 1.997.014 2.746.764.75 2.042.735 2.747.03l8.697-8.697 8.682 8.682c.734.734 1.998.735 2.747-.015.749-.764.749-2.012.014-2.747l-8.681-8.682 8.681-8.696c.735-.735.75-1.998-.014-2.747-.75-.75-2.013-.75-2.747-.015l-8.682 8.682L3.305.549C2.6-.17 1.307-.2.558.564-.19 1.313-.176 2.606.544 3.31l8.681 8.696z"
  })));
};
export default SvgCrossAttachment;